import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function LoadingMoreOrders(props) {
  const { t } = useTranslation(['description']);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height={20}
      width="100%"
      gap={1}
      ref={props.reference}
    >
      <CircularProgress size={20} />
      <Typography variant="body1">
        {t('loading_more_orders', { ns: 'description' })}
      </Typography>
    </Box>
  );
}
